import styled, { keyframes, css } from "styled-components";
import TitleText from '../ui/Title';
import importImage from './ImportImage'
 
import React, { useEffect, useState, useRef  } from 'react';
const WrapperContainer = styled.div`
  display: flex;            
  flex-direction: column;    
  align-items: center;  
  justify-content: center;
`;
const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
 
    color: white;
 
    margin: 200px 0 200px 0;
 @media (max-width: 965px) {
    flex-direction: column;
        align-items: center;  
  justify-content: center;
  }
`;



const Image = styled.img`
 max-width: 80%;
 max-height: 50%;
  height: auto;
  display: block;
  margin: 60px;
 justify-self: center;
 @media (max-width: 965px) {
    max-width: 100%;
  }
`;


 

const LogoImage = styled.img`
    
  width: 420px;  
  height: auto;
  display: block;
  justify-self: center;
 
  
 
`;

const slideUp = keyframes`
  from {
    transform: translateY(90%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;
const Container = styled.div`
  text-align: center;
  max-width: 30vw;
  margin: 0 auto;

  @media (max-width: 965px) {
    display: flex;            
  flex-direction: column;    
  align-items: center;  
  justify-content: center;
    max-width: 80vw;
    
  }

 
  ${({ inView }) =>
    inView &&
    css`
      p, h1, h2, h3 {
        animation: ${slideUp} 1s ease-out forwards;
      }
    `}
`;
 
 const Paragraph = styled.p`
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 16px;
`;
function About() {
  const [imageSrc1, setImageSrc1] = useState("");
  const [imageSrc2, setImageSrc2] = useState("");
    const [imageSrc3, setImageSrc3] = useState("");
  const [inView, setInView] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.unobserve(entry.target); 
        }
      },
      { threshold: 0.2 }  
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, []);

  useEffect(() => {
    const loadImages = async () => {
      await importImage("dish.webp", setImageSrc1);
      await importImage("korean.webp", setImageSrc2);
       await importImage("deco.gif", setImageSrc3);
    };
    loadImages();
  }, []);


  return (
    <WrapperContainer> 
    <Wrapper id="about-me" ref={ref}>
   
      <Container inView={inView}>
          
          <TitleText>
            <span>Welcome to Tong Fei!</span>
          </TitleText>
           <Paragraph> 
            Tong Fei is a newly opened restaurant offering a bold and flavorful fusion of Korean and Chinese cuisine

            Tong Fei is proud to announce its grand reopening under new ownership. </Paragraph>
            <Paragraph> While honoring the flavors that made this location a favorite in the community, we’re bringing a fresh new vision to the table—with refined dishes, thoughtful service, and a warm, inviting atmosphere.  </Paragraph>
            <Image src={imageSrc1}/>

      </Container>

      <Container inView={inView}>
          <Image src={imageSrc2}/>
            <TitleText>Korean-Chinese Fusion, Reimagined  </TitleText>
          <Paragraph> At Tong Fei, we serve a unique fusion of Korean and Chinese cuisine, combining the bold, comforting flavors of both traditions. Whether you're in the mood for classic favorites like Jajangmyeon and TangSooYuk or curious to explore our fusion creations, each dish is crafted with care and creativity. </Paragraph>
     
        </Container>
    </Wrapper>
    <LogoImage src={imageSrc3}/>
    <TitleText 
      style={{ 
        color: 'white', 
       
        fontSize: '48px',  
        paddingBottom: '10px',  
      }}
    >
            Menu
      </TitleText>
      <hr></hr>
    </WrapperContainer>
  );
}

export default About;
